import React, { useState } from "react";
import propTypes from "prop-types";
import {
  Form, FormGroup, Input, Label, Button, FormFeedback, Spinner,
} from "reactstrap";

import { Instruction } from "./Instruction";

export const ChooseField = ({
  field, handleChange, showNoDataAlert, isLoading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const submitNewField = () => {
    handleChange({ isLoading: true });
  };
  return (
    <Form>
      <Instruction isOpen={isOpen} toggle={toggle} />
      <FormGroup>
        <Label>Field :</Label>
        <Input type="text" value={field} invalid={showNoDataAlert} onChange={(e) => { handleChange({ field: e.target.value }); }} />
        <FormFeedback>This field has no data</FormFeedback>
      </FormGroup>
      <div className="d-flex justify-content-center">
        <Button type="button" className="mx-2" color="primary" onClick={submitNewField} disabled={isLoading}>
          {isLoading ? (
            <div className="d-flex align-items-center">
              <Spinner />
              <div className="text-center" style={{ paddingLeft: "10px" }}>Loading...</div>
            </div>
          ) : "Submit"}
        </Button>
        <Button type="button" className="mx-2" color="primary" onClick={toggle}>Instruction</Button>
      </div>
    </Form>
  );
};

ChooseField.propTypes = {
  field: propTypes.string.isRequired,
  handleChange: propTypes.func.isRequired,
  showNoDataAlert: propTypes.bool.isRequired,
  isLoading: propTypes.bool.isRequired,
};
